module.exports = __webpack_public_path__ + "static/sunset-mountains-embed-b68c72332127d704384911a0c29cad84.svg";